import React from 'react';

export const GlassCtaButton = ({
  label,
  onClick,
  icon,
  isLoading = false,
  variant = 'primary', // 'primary', 'secondary', 'danger'
  fullWidth = true,
  disabled = false,
  className = '',
  type = 'button',
  ...props
}) => {
  const isDisabled = disabled || isLoading || !onClick;

  const combinedStyle = {
    width: fullWidth ? '100%' : 'auto',
    ...props.style
  };

  return (
    <button
      type={type}
      className={`glass-cta-button ${variant !== 'primary' ? variant : ''} ${className}`}
      onClick={onClick}
      disabled={isDisabled}
      {...props}
      style={combinedStyle}
    >
      {isLoading ? (
        <span className="spinner" />
      ) : (
        <>
          {icon && <span className="icon">{icon}</span>}
          <span className="label">{label}</span>
        </>
      )}
    </button>
  );
};